import { Stack, Typography } from '@mui/material';
import React from 'react';
import ship from '../../../../assets/images/ferry.svg'
import handshake from '../../../../assets/images/handhshakeGreen.svg'
import CWLogo from '../../../../assets/images/CWLogo.png'

export default function NotificationCard({ data, onClick }) {
  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      flex={1}
      style={{ borderBottomWidth: '1px', borderColor: '#F2F2F2', padding:'10px', backgroundColor: data?.status === '2'  ? "#14285A17" : "#FFFFFF", cursor:'pointer' }}
      onClick={() => onClick(data)}
    >
      <Stack
        style={{ height: '32px', width: '32px', borderRadius: '16px', backgroundColor: data?.subType === 'fleet' ?  '#00339926' : data?.subType === 'trade' ? "#00A6321A": null }}
        alignItems={'center'}
        justifyContent={'center'}
      >
        {data?.subType === 'fleet' ?  <img src={ship} /> : data?.subType === 'trade' ? <img src={handshake} /> : <img src={CWLogo} />}
       
      </Stack>
      <Stack
        className="ml-[16px]"
        flex={1}
      >
        <Typography className="fw-regular ff-Medium fs-12">{data?.title}</Typography>
        <Typography
          className="fw-regular ff-Roboto fs-12"
          color={'#14285ABD'}
        >
          {data?.content}
        </Typography>
      </Stack>
    </Stack>
  );
}
